import * as institutionActions from '../actions/institution.actions';
import { createFeatureSelector, createSelector } from '@ngrx/store';

export interface InstitutionState {
    institutionDetail?: any;
    loading: boolean;
    loaded: boolean;
}

const initialState = {
    institutionDetail: null,
    loading: false,
    loaded: false
};

export const institutionReducer = (state = initialState, action) => {
    switch (action.type) {
        case institutionActions.GET_INSTITUTION_CURRENT:
            return {
                ...state,
                loading: true,
                loaded: false
            };

        case institutionActions.GET_INSTITUTION_CURRENT_SUCCESS:
            return {
                ...state,
                institutionDetail: action.payload,
                loading: false,
                loaded: true
            };
        case institutionActions.GET_INSTITUTION_CURRENT_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false,
                loaded: false
            };
        case institutionActions.CLEAR_INSTITUTION_CURRENT:
            return {
                ...state,
                institutionDetail: null,
                loading: null,
                loaded: null
            }
        default:
            return state;
    }
};

export const getInstitutionState = createFeatureSelector<InstitutionState>('institutionReducer');
export const getInstitutionCurrent = (state: InstitutionState) => state.institutionDetail;
export const getInstitutionLoading = (state: InstitutionState) => state.loading;
export const getInstitutionLoaded = (state: InstitutionState) => state.loaded;
